export default __webpack_public_path__ + "6447ddc9513a9e63d6b85af3bbeec029.png";